import React, { useState } from "react";
import './imagePreview.css';
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileArchive, FaRegFileAlt } from "react-icons/fa";

const ImageGallery = ({ images = [], changeImageOrder }) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (index, e) => {
    e.preventDefault();
    if (index !== draggedIndex) {
      const reordered = [...images];
      const draggedItem = reordered[draggedIndex];
      reordered.splice(draggedIndex, 1);
      reordered.splice(index, 0, draggedItem);
      setDraggedIndex(index);
      changeImageOrder(reordered);
    }
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  const handleDelete = (index) => {
    const deleteImage = images.filter((_, i) => i !== index);
    changeImageOrder(deleteImage);
  };

  const isImageFile = (key) => {
    const ext = key.split(".").pop().toLowerCase();

    return ["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext);
  }

  // ✅ Get Icon for Non-Image Files
  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();

    switch (ext) {
      case "pdf":
        return <FaFilePdf size={50} color="red" />;

      case "doc":
      case "docx":
        return <FaFileWord size={50} color="blue" />;

      case "xls":
      case "xlsx":
        return <FaFileExcel size={50} color="green" />;

      case "zip":
      case "rar":
        return <FaFileArchive size={50} color="orange" />;

      default:
        return <FaRegFileAlt size={50} color="gray" />;
    }
  };

  return (
    <div className="gallery-container">
      {Array.isArray(images) && images.map((img, index) => (
        <div
          key={index}
          className="image-card"
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => handleDragOver(index, e)}
          onDragEnd={handleDragEnd}
        >
          {isImageFile(img.fileName) ? (
            <img src={img.url} alt={img.fileName} className="image-preview" />
          ) : (
            <div className="file-preview" title={img.fileName}>
              <div className="file-icon">
                {getFileIcon(img.fileName)}
              </div>

              <div className="file-name">
                {img.fileName}
              </div>
            </div>
          )}

          <div className="overlay">
            <button className="delete-btn" onClick={() => handleDelete(index)}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
